import Vue from 'vue'
import Component from 'vue-class-component'
import $ from 'jquery'

@Component
export class DropdownExtension extends Vue {
  public adjustPosition(): void {
    // hold onto the drop down menu
    let dropdownMenu: JQuery<HTMLElement>

    // and when you show it, move it to the body
    $(window).on('shown.bs.dropdown', function (e) {
      // grab the menu
      dropdownMenu = $(e.target).closest('.dropdown-adjusted').find('.dropdown-menu')
      console.log(dropdownMenu)
      if (dropdownMenu.length === 0) { return }

      $('body').append(dropdownMenu.detach())

      const parent = $(e.target)

      const dropdownParentWidth = parent.outerWidth() ?? 50
      const dropdownParentHeight = parent.outerHeight() ?? 50
      const dropdownWidth = dropdownMenu.outerWidth() ?? 50
      const dropdownHeight = dropdownMenu.outerHeight() ?? 50

      const parentTop = parent.offset()?.top ?? 0
      const parentLeft = parent.offset()?.left ?? 0
      const parentBottom = parentTop + dropdownParentHeight

      let top = parentTop

      if (parentTop + dropdownHeight >= window.innerHeight) {
        top = parentBottom - dropdownHeight - 4
      }
      dropdownMenu.css({
        top: top,
        left: parentLeft + (dropdownParentWidth / 2 - dropdownWidth / 2)
      })
    })

    $(window).on('hide.bs.dropdown', function (e) {
      console.log(e)
      $(e.target).append(dropdownMenu.detach())
    })
  }
}
